import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAuthStore } from '@/store/authStore';
import { validatePhoneNumber } from '@/utils/validation';

interface LoginFormData {
  phoneNumber: string;
  password: string;
}

export function LoginForm() {
  const { login, isLoading, error } = useAuthStore();
  const navigate = useNavigate();
  
  const { register, handleSubmit, formState: { errors } } = useForm<LoginFormData>();

  const onSubmit = async (data: LoginFormData) => {
    try {
      const success = await login(data.phoneNumber, data.password);
      if (success) {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="phoneNumber">رقم الجوال</Label>
          <Input
            id="phoneNumber"
            type="tel"
            dir="ltr"
            className="text-left"
            {...register('phoneNumber', {
              required: 'رقم الجوال مطلوب',
              validate: validatePhoneNumber
            })}
            placeholder="05xxxxxxxx"
          />
          {errors.phoneNumber && (
            <p className="text-sm text-red-500">{errors.phoneNumber.message}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="password">كلمة المرور</Label>
          <Input
            id="password"
            type="password"
            {...register('password', {
              required: 'كلمة المرور مطلوبة',
              minLength: { value: 6, message: 'يجب أن تتكون كلمة المرور من 6 أرقام' },
              maxLength: { value: 6, message: 'يجب أن تتكون كلمة المرور من 6 أرقام' },
              pattern: { value: /^\d{6}$/, message: 'يجب أن تتكون كلمة المرور من 6 أرقام فقط' }
            })}
            placeholder="******"
            maxLength={6}
          />
          {errors.password && (
            <p className="text-sm text-red-500">{errors.password.message}</p>
          )}
        </div>

        <Button type="submit" className="w-full" disabled={isLoading}>
          {isLoading ? 'جاري تسجيل الدخول...' : 'دخول'}
        </Button>
      </div>

      {error && (
        <p className="text-sm text-red-500 text-center">{error}</p>
      )}
    </form>
  );
}